import React, { useState, MouseEvent } from 'react';
import { Toast } from 'react-bootstrap';

type ErrorBoundaryProps = {
  componentStack: string | null;
  error: Error;
};

export const ErrorBoundary = ({ componentStack, error }: ErrorBoundaryProps): JSX.Element => {
  const [showToast, setShowToast] = useState<boolean>(false);

  const copyErrorHandler = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    const errorMessage = `Error: ${error.name} - ${error.message}\n\nDetails: \n${componentStack}`;
    navigator.clipboard.writeText(errorMessage);
    setShowToast(true);
  };

  return (
    <>
      <Toast
        delay={1000}
        autohide
        onClose={() => setShowToast(false)}
        show={showToast}
        style={{ position: 'fixed', top: '5vh', right: '45%', zIndex: 1000 }}
      >
        <Toast.Body>Copied to clipboard</Toast.Body>
      </Toast>
      <div className="app">
        <div className="animated fadeIn mx-auto my-5 error-container">
          <a href="/" className="brand">
            &nbsp;
          </a>

          <h3 className="">Oops, something went wrong</h3>

          <p className="pt-2">
            Please refresh the page to continue or{' '}
            <b>
              <a href="/">click here to go to the home page</a>
            </b>
            .
          </p>
          <p className="pt-4">
            To contribute to the development of Corsmed please send the below details to Corsmed Support via &nbsp;
            <a href="mailto:support@corsmed.com">
              <b>support@corsmed.com</b>
            </a>
            , thank you!
          </p>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <details style={{ whiteSpace: 'pre-wrap' }} open>
              <summary>
                Expand crash report
                <span className="error-container__copy-error" role="presentation" onClick={copyErrorHandler}>
                  <i className="fa fa-copy me-2" />
                </span>
              </summary>
              <p className="py-3 my-0 px-3">
                {error && error.toString()}
                <br />
                {componentStack}
              </p>
            </details>
          </div>
        </div>
      </div>
    </>
  );
};
